module.exports = __webpack_public_path__ + "static/media/example-2.99e38200.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/HearthHouse/example-2.jpg
// module id = 204
// module chunks = 0